export default "__VITE_ASSET__f7ef7635__"